(function captureAttribution(){
  if (typeof mixpanel === "undefined") return;

  const params = new URLSearchParams(window.location.search);

  const props = {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
    gclid: params.get("gclid")
  };

  Object.keys(props).forEach(k => props[k] === null && delete props[k]);

  if (Object.keys(props).length > 0) {
    mixpanel.register(props);
  }
})();



function mpTrack(name, props){
  if (!window.mixpanel) return;
  mixpanel.track(name, props || {});
}

  // ---- CART ADD INTERCEPT ----
(function() {
  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = args[0];

      if (typeof url === "string" && url.includes("/cart/add")) {
        const body = args[1]?.body;

        mpTrack("add_to_cart", {
          source: "ajax_intercept",
          request: body ? body.toString() : null
        });

        console.log("MP add_to_cart tracked");
      }
    } catch(e){}

    return response;
  };
})();
// ---- CHECKOUT INTENT TRACK ----
(function(){

  document.addEventListener("click", function(e){

    const el = e.target.closest("a,button,input");

    if(!el) return;

    const href = el.href || "";
    const text = (el.innerText || el.value || "").toLowerCase();

    const isCheckout =
      href.includes("/checkout") ||
      text.includes("checkout") ||
      text.includes("secure checkout") ||
      text.includes("continue to payment");

    if(isCheckout){
      mpTrack("checkout_started", {
        source: "ui_intent",
        page: location.pathname
      });

      console.log("MP checkout tracked");
    }

  });

})();

// ===============================
// SESSION BEHAVIOR TRACKING
// ===============================

// TIME ON PRODUCT
if (document.body.className.includes("template-product")) {

  const start = Date.now();

  window.addEventListener("beforeunload", () => {
    mixpanel.track("time_on_product", {
      seconds: Math.round((Date.now() - start)/1000)
    });
  });
}


// SCROLL DEPTH
let maxScroll = 0;

window.addEventListener("scroll", () => {
  const scroll = Math.round(
    (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100
  );

  if(scroll > maxScroll){
    maxScroll = scroll;
  }
});

window.addEventListener("beforeunload", () => {
  mixpanel.track("scroll_depth", {
    percent: maxScroll
  });
});


// RAGE CLICK DETECTION
let clicks = [];

document.addEventListener("click", (e) => {
  const now = Date.now();
  clicks.push(now);

  clicks = clicks.filter(t => now - t < 1000);

  if(clicks.length >= 5){
    mixpanel.track("rage_click", {
      element: e.target.tagName
    });
    clicks = [];
  }
});
